export interface DrawerPillColor {
  backgroundColor: string;
  color: string;
}

/** Per-pill palette for concept tags (Figma teal family + distinct accents). */
export const DRAWER_CONCEPT_PILL_COLORS: DrawerPillColor[] = [
  { backgroundColor: "rgba(1, 245, 200, 0.15)", color: "#00997d" },
  { backgroundColor: "rgba(108, 75, 255, 0.15)", color: "#6c4bff" },
  { backgroundColor: "rgba(251, 146, 60, 0.18)", color: "#c2410c" },
  { backgroundColor: "rgba(59, 130, 246, 0.15)", color: "#1d4ed8" },
  { backgroundColor: "rgba(244, 63, 94, 0.15)", color: "#be123c" },
  { backgroundColor: "rgba(34, 197, 94, 0.15)", color: "#15803d" },
];

/** Per-pill palette for sequence tags (Figma slate family + distinct accents). */
export const DRAWER_SEQUENCE_PILL_COLORS: DrawerPillColor[] = [
  { backgroundColor: "#eeeef4", color: "#464b67" },
  { backgroundColor: "rgba(108, 75, 255, 0.12)", color: "#5b4bcc" },
  { backgroundColor: "rgba(1, 245, 200, 0.12)", color: "#0f766e" },
  { backgroundColor: "rgba(251, 191, 36, 0.18)", color: "#b45309" },
  { backgroundColor: "rgba(96, 165, 250, 0.18)", color: "#1e40af" },
  { backgroundColor: "rgba(244, 114, 182, 0.18)", color: "#9d174d" },
];

export function drawerPillColorAt(palette: DrawerPillColor[], index: number): DrawerPillColor {
  return palette[index % palette.length]!;
}
